import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import Box from '@material-ui/core/Box';

import Pana from './Pana.json';
import Cuate from './Cuate.json';
import Super from './Super.json';

interface IPillarsAnimations {
  animationHeight?: number;
  animationWidth?: number;
  containerWidth?: string;
  speed?: number;
  type: 'energy' | 'efficacy' | 'constancy';
}

const PillarsAnimations: React.FC<IPillarsAnimations> = ({
  containerWidth = '50%',
  animationHeight = '100%',
  animationWidth = '100%',
  speed,
  type,
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
  };

  const [animationSpeed, setSpeed] = useState(1);

  useEffect(() => {
    if (speed) {
      setSpeed(speed);
    }
  }, []);

  const selectType = () => {
    if (type === 'energy') {
      return Super;
    } else if (type === 'efficacy') {
      return Pana;
    } else {
      return Cuate;
    }
  };

  return (
    <Box display="flex" width={containerWidth} justifyContent="center" alignItems="center">
      <Lottie
        options={{ ...defaultOptions, animationData: selectType() }}
        height={animationHeight}
        width={animationWidth}
        speed={animationSpeed}
      />
    </Box>
  );
};

export { PillarsAnimations };
